/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */

export class StoreInstantMsg {
  id: number;
  instantMsgType: StoreInstantMsgType;
  instantMsg: string;

  constructor() {
    this.id = 0;
    this.instantMsgType = null;
    this.instantMsg = "";
  }
}

export enum StoreInstantMsgType {
  skype = "Skype",
  facebookMessenger = "FB Messenger",
  whatsapp = "Whatsapp",
  other = "Other",
}

/* © 2018-2022 TakuLabs Ltd. All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential */
